import Vue from "vue";
import App from "./App.vue";

import store from "./store";
import ElementUI from "element-ui";
import "./permission";

import "./styles/common.css";
import "./api/request";

import "element-ui/lib/theme-chalk/reset.css";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import strings from "./constant/strings";
import projectConfig from "./constant/projectConfig";
import { getRequest, postRequest } from "./api/request";
import VueClipboard from "vue-clipboard2";

Vue.prototype.strings = strings;
Vue.prototype.projectConfig = projectConfig;
Vue.prototype.$get = getRequest;
Vue.prototype.$post = postRequest;

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard);//点击复制

Vue.directive("permission", {
  inserted(el, binding) {
    const { value } = binding;
    const permissions = store.state.permissions;

    // 检查是否是超级管理员
    if (!permissions.includes("all") && value && !permissions.includes(value)) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  },
});

Vue.directive("removeAriaHidden", {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  },
});
Vue.prototype.$jumpPerm = function (code) {
  //校验是否有跳转权限
  return store.state.permissions.includes(code) || store.getters.isAdmin;
};
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
